export default {
  text: 'Zdobywasz <highlight>{{value}} punktów</highlight> za to zamówienie',
};
